import { Icon, IconName, IndicatorBadge, Tooltip } from '@talos/kyoko';
import type { CSSProperties } from 'react';

export const LABEL_COLOR_STYLE: CSSProperties = { color: 'var(--colors-gray-090)' };
export const NOT_CONSIDERED_LABEL_STYLE: CSSProperties = { ...LABEL_COLOR_STYLE, opacity: 0.5 };

export function NotConsideredLabelSuffix() {
  return (
    <Tooltip tooltip="This field was not considered in the pre-trade analysis" placement="top">
      <IndicatorBadge
        w={16}
        h={16}
        p={0}
        background="backgroundDefaultButton"
        borderRadius="borderRadiusSmall"
        aria-label="Not considered in pre-trade analysis"
        role="img"
      >
        <Icon icon={IconName.Ban} color="colorTextSubtle" size={12} />
      </IndicatorBadge>
    </Tooltip>
  );
}
